import BaseModel from "../models/BaseModel";
import type BaseObject from "../models/BaseObject";
import type { ConnectionAnalyser } from "./ConnectionAnalyser";
import { deleteVirtualConnection, isVirtualConnection } from "./VirtualConnections";

/** Adapts derived wiring to normal app selection without registering or persisting a model. */
export class VirtualConnectionSelection extends BaseModel {
  constructor(private readonly analyser: ConnectionAnalyser, connectionId: string) {
    super({ storeInObjectRegistry: false, isPersistent: false });
    this._id = connectionId;
  }

  get className(): string { return "VirtualConnection"; }

  /** Always uses the current graph so refreshes cannot leave deletion targeting stale assignments. */
  private get connection() {
    const connection = this.analyser.connections.find(item => item.id === this.id);
    return connection && isVirtualConnection(connection) ? connection : undefined;
  }

  get nameOfDefaultName(): string {
    const connection = this.connection;
    return connection ? `${connection.fromDevice.nameOfDefaultName} → ${connection.toDevice.nameOfDefaultName}` : "Verbindung";
  }

  canBeDeletedInteractive(): boolean { return !!this.connection; }
  canBeCopiedInteractive(): boolean { return false; }
  canBeEditedInteractive(): boolean { return false; }

  delete(): BaseObject[] {
    const connection = this.connection;
    if (connection) deleteVirtualConnection(connection);
    return [];
  }
}
